import React, { useRef, useEffect } from "react";
import "./InfiniteCarousel.scss";

const InfiniteCarousel = ({ items }) => {
  const trackRef = useRef(null);

  useEffect(() => {
    const track = trackRef.current;
    let position = 0;

    const smoothScroll = () => {
      position -= 0.3; // Adjust speed here (1px per frame)
      const trackWidth = track.scrollWidth / 2; // Total width of one set of items

      if (Math.abs(position) >= trackWidth) {
        position = 0; // Reset to the start for a seamless loop
      }

      track.style.transform = `translateX(${position}px)`;
      requestAnimationFrame(smoothScroll);
    };

    smoothScroll();

    return () => cancelAnimationFrame(smoothScroll); // Cleanup animation on unmount
  }, []);

  return (
    <div className="carousel-container">
      <div ref={trackRef} className="carousel-track">
        {/* Duplicate items for seamless looping */}
        {items.concat(items).map((item, index) => (
          <div key={index} className="carousel-item">
            <img src={item.image} style={item.style} alt={item.name} className="image" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default InfiniteCarousel;
